import React, { useEffect, useState } from "react";
import { RoundedButton } from "../../../../../elements";
import { vaultStore } from "../../store/VaultStore";
import {
  ModalWrapper,
  ModalContent,
  ModalBody,
  ModalFooter,
  InputLabel,
  InputWrapper,
  StyledInput,
  StyledTextArea,
} from "./RenameVaultModal.styled";

const RenameVaultModal = (props) => {
  const {
    isOpen,
    onClose,
    onSubmit,
    currentName,
    description,
    fileId,
    created_by,
    files_stored,
  } = props;

  const [vaultName, setVaultName] = useState(currentName || "");
  const [vaultDescription, setVaultDescription] = useState(description || "");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setVaultName(currentName || "");
    setVaultDescription(description || "");
  }, [currentName, description]);


  if (!isOpen) return null;
  
  const handleSubmit = async (e) => {
    e.stopPropagation();
    if (!vaultName.trim()) return;

    setIsSubmitting(true);
    const success = await vaultStore.renameDocumentFolder({
      folderId: fileId,
      newName: vaultName.trim(),
      description: vaultDescription.trim(),
      created_by: created_by,
      files_stored: files_stored,
    });
    setIsSubmitting(false);

    if (success) {
      onSubmit(vaultName.trim(), vaultDescription.trim());
    }
  };

  const handleClose = (e) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <ModalWrapper onClick={(e) => e.stopPropagation()}>
      <ModalContent role="dialog" onClick={(e) => e.stopPropagation()}>
        <ModalBody>
          <InputWrapper>
            <InputLabel>Vault Name</InputLabel>
            <StyledInput
              type="text"
              value={vaultName}
              onChange={(e) => setVaultName(e.target.value)}
              placeholder="Enter vault name"
              disabled={isSubmitting}
              onClick={(e) => e.stopPropagation()}
            />
          </InputWrapper>
          <InputWrapper style={{ marginTop: "16px" }}>
            <InputLabel>Description</InputLabel>
            <StyledTextArea
              value={vaultDescription}
              onChange={(e) => setVaultDescription(e.target.value)}
              placeholder="Enter vault description"
              disabled={isSubmitting}
              onClick={(e) => e.stopPropagation()}
              rows={4}
            />
          </InputWrapper>
        </ModalBody>
        <ModalFooter>
          <RoundedButton
            kind="default"
            outline
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Discard changes
          </RoundedButton>
          <RoundedButton
            kind="blue"
            onClick={handleSubmit}
            disabled={isSubmitting || !vaultName.trim()}
          >
            {isSubmitting ? "Renaming..." : "Update vault"}
          </RoundedButton>
        </ModalFooter>
      </ModalContent>
    </ModalWrapper>
  );
};

export default RenameVaultModal;
